import LogsTable from './_table.js'
import template from './index.pug'
import API from 'js/services/api'

export default Vue.extend({
  template: template(),
  components: {
    LogsTable
  },
  data() {
    return {
      logs: [],
      meta: {},
    }
  },
  created() {
    this.$setPageTitle(this.$t('logsLogin.index.title'))
    this.$setBreadcrumbs([
      { label: this.$t('logsLogin.index.breadcrumbs.index'), route: {} }
    ])
    this.loadLogs()
  },
  methods: {
    loadLogs(queryOptions = {}) {
      console.log("📡 Enviando petición a API.loginAudit.index con:", queryOptions)

      API.loginAudit.index(queryOptions)
        .then(({ data, meta }) => {
          this.logs = data         
          this.meta = meta
        })
        .catch(error => {
          this.logs = []
          //this.meta = { page: 1, perPage: 20, total: 0 }
        })
    }
  }
})
